import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCalendarStyle0 = gravityIconIndividualCss;

const GravityIconCalendar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '5e3836f084e7cb7538363cfe624b8a54dd4165d2', color: this.color, size: this.size }, h("svg", { key: '462ca9bc08cc26b6405a43355ffcf4b2452c705e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '68f4b3d183f9393155d2c7a9c44d94e103582933', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 3h-4V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v1H9V2a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v1h-4a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5Zm-1 14.5h-13v-13h3v1A.5.5 0 0 0 8 6h.5a.5.5 0 0 0 .5-.5v-1h4v1a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-1h3v13Z", fill: "currentColor" }))));
    }
};
GravityIconCalendar.style = GravityIconCalendarStyle0;

export { GravityIconCalendar as gravity_icon_calendar };

//# sourceMappingURL=gravity-icon-calendar.entry.js.map